var giphy_viewer_default = {
  "giphyWrapper": "dFLKf",
  "giphy_player": "qJ3B-",
  "playIcon": "kGMQ-",
  "gifRatio": "y19z9"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
